import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from './assets/WeChat_ma.png';

var _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "topnav"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, [/*#__PURE__*/_createTextVNode(" <关注我们> "), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "ma"
})])], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_MainHead = _resolveComponent("MainHead");

  var _component_router_view = _resolveComponent("router-view");

  var _component_MainFoot = _resolveComponent("MainFoot");

  return _openBlock(), _createElementBlock("div", null, [_hoisted_1, _createVNode(_component_MainHead, {
    class: "head"
  }), _createVNode(_component_router_view), _createVNode(_component_MainFoot)]);
}